export default function FormStepper({ steps, activeStep }) {
  return (
    <div className="flex gap-16 my-8 bg-form-header px-6 rounded-t-xl">
      {steps.map((step, index) => (
        <div
          key={step.key}
          className={
            index === activeStep ?
              "font-bold cursor-pointer border-b-2 pb-2 p-4 border-menu-selected bg-linear-to-t from-menu-selected/50 to-menu-selected/10" :
              "cursor-pointer opacity-40 p-4"
          }
        >
          {step.title}
        </div>
      ))}
    </div>
  );
}
